
export const IS_EDITING_FORM = 'IS_EDITING_FORM';
export const IS_EDIT_PAGE = 'IS_EDIT_PAGE';
export const UPDATE_DA_REQUEST = 'UPDATE_DA_REQUEST';
export const UPDATE_DA_SUCCESS = 'UPDATE_DA_SUCCESS';
export const UPDATE_DA_FAILURE = 'UPDATE_DA_FAILURE';